import { WSPosterProps } from "@wingspanhq/fe-component-library";
import {
  SharedFileRequest,
  SharedFileRequestStatus
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { EmptyComponent } from "../../../../../../shared/components/EmptyComponent";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { selectorSharedFileExtractedFields } from "../../../../selectors/selectorSharedFileExtractedFields";
import { RequirementTableItemData } from "../../../../types";
import { ValidationProgress } from "../../components/ValidationProgress";
import { getSharedFileIsValidatingActive } from "../helpers/getSharedFileIsValidatingActive";

export const payeeSharedFileRenderCardDescription = (
  requirement: RequirementTableItemData,
  sharedFileRequest?: SharedFileRequest
) => {
  const sharedFileRequestDescriptions: Record<
    SharedFileRequestStatus,
    WSPosterProps
  > = {
    [SharedFileRequestStatus.PENDING_UPLOAD]: {
      type: "documents",
      title: "File not uploaded",
      description: "Waiting for the contractor to upload a file."
    },
    [SharedFileRequestStatus.PENDING_SUBMISSION]: {
      type: "documents",
      title: "Verification has failed.",
      description:
        "Contractor has a few attempts to try to upload the file again."
    },
    [SharedFileRequestStatus.PROCESSING]: {
      type: "documents",
      title: "Verification in progress",
      description:
        "The contractor's file is being verified. This may take a few minutes."
    },
    [SharedFileRequestStatus.FAILED]: {
      type: "documents",
      title: "File uploading has failed",
      description: "Something went wrong while uploading the file."
    },
    [SharedFileRequestStatus.COMPLETE]: {
      type: "done",
      title: "Your file upload is complete",
      description: "You can download the file below."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus:
      sharedFileRequest?.status || SharedFileRequestStatus.PENDING_UPLOAD,
    documentStatuses: sharedFileRequestDescriptions,
    pendingApprovalStatus: {
      type: "documents",
      title: "Document was uploaded",
      description:
        "The document was uploaded. The requirement now requires approval."
    },
    rejectedStatus: {
      type: "documents",
      title: "Document was rejected",
      description:
        "The requirement was rejected and may affect the contractor’s eligibility for related engagements."
    },
    approvedStatus: null,
    customContent: getSharedFileIsValidatingActive(sharedFileRequest) ? (
      <ValidationProgress jobs={sharedFileRequest?.jobs} />
    ) : selectorSharedFileExtractedFields(sharedFileRequest) ? (
      <EmptyComponent />
    ) : null
  });
};
